import React from 'react';
import { CalendarIcon } from '@radix-ui/react-icons';

import { dateShort } from '../../assets/contants/dates-fns';
import { formatDate } from '../../lib/utils/DateHelper';
import { openDateSelectionModal } from './open-date-selection-modal';
import { type PlainDate } from '../../core/services/plain-date';
import { TaskPropertyButton } from '../../features/tasks/components/task-property.button';

interface DateSelectorProps {
  date?: PlainDate | null;
  min?: PlainDate | null;
  max?: PlainDate | null;
  placeholder?: string;
  onUpdate: (value: PlainDate | null) => void;
  field: 'startDate' | 'dueDate';
  disabled?: boolean;
}

/**
 * The property-button trigger for one date field. Everything about the modal itself — minting a
 * `PlainDate`, forwarding a cleared field as `null`, and the min/max range check — lives in
 * `openDateSelectionModal`, shared with the Calendar view's right-click menu (PRO-1073).
 */
export const DateSelector: React.FC<DateSelectorProps> = ({
  date,
  field,
  onUpdate,
  max,
  min,
  placeholder = 'Set date',
  disabled,
}) => (
  <TaskPropertyButton
    isDisabled={disabled}
    isActive={!!date}
    onClick={() => openDateSelectionModal({ field, value: date, min, max, onUpdate })}
    icon={<CalendarIcon />}
    label={date ? formatDate(date, dateShort) : placeholder}
  />
);
